<template>
    <div class="main">
        <div class="admin-section">
            <form class="container" @submit="onSubmit">
                <div class="row">
                    <h1 class="section-heading col-12">Login</h1>
                </div>
                <b-form-group label="Email:"
                                label-for="email"
                                invalid-feedback="A valid email should be passed."
                                :state="emailState">
                    <b-form-input id="email"
                                v-model="email"
                                required
                                :state="emailState"
                                type="email"
                                trim></b-form-input>
                </b-form-group>
                <b-form-group label="Password:"
                                label-for="pass"
                                invalid-feedback="Password is required."
                                :state="passState">
                    <b-form-input id="pass"
                                v-model="pass"
                                required
                                :state="passState"
                                type="password"
                                trim></b-form-input>
                </b-form-group>
                <div class="buttons-container float-right">
                    <b-button type="submit" class="submit-button">Login</b-button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>

import { auth, signIn } from "../../firebase";

export default {
    name: "LogIn",
    data() {
        return {
            email: null,
            pass: null
        }
    },
    computed: {
        emailState() {
            return !!this.email && !!this.email.toLowerCase()
                .match(
                    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                );
        },
        passState() {
            return this.pass && this.pass.length > 0 ? true : false;
        },
    },
    methods: {
        onSubmit(e) {
            e.preventDefault();

            signIn(auth, this.email, this.pass)
                .then(() => {
                    this.$router.push('/admin/fleet');
                }).catch((error) => {
                    alert('Login failed!\n' + error.message.replace('Firebase: ', ''));
                });
        }
    },
    mounted() {
        if (auth.currentUser) {
            this.$router.push('/admin/fleet');
        }
    }
}
</script>
